import React, { ReactNode } from 'react'

const Heading3 = ({...props}:{children:string | ReactNode ,classname?:string}) => {
  return (
    <h3 className={`text-2xl font-semibold ${props.classname}`}>{props.children}</h3>
  )
}

export default Heading3